<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-26 14:38:03
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-06-08 13:56:44
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/components/FoodTypeView/index.vue
-->
<template>
    <div class="food-container">
        <h1>食物类型</h1>
        <div class="food-view">
            <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
                <el-tree 
                ref="treeRef"
                :data="foodTreeData" 
                node-key="id"
                highlight-current
                accordion
                :props="defaultProps" 
                @node-click="handleNodeClick">
                </el-tree>
                <!-- 
                :default-expanded-keys="defaultExpandedKeys"
                :default-checked-keys="['1397114980529795172']"

                 -->
            </el-scrollbar>
        </div>
    </div>
</template>
<script>
import eventBus from '@/utils/eventBus'
export default {
    name:'FoodTypeView',
    props:{
        foodTreeData:{
            type:Array,
            default:()=>[]
        },
        
        // defaultExpandedKeys:{
        //     type:Array,
        //     default:()=>[],
        // }
    },
    data(){
         return{
            defaultExpandedKeys:[],//新增后需要传递具体新增的哪一项
            defaultProps: {
                children: 'children',
                label: 'categoryName'
            }
        }
    },
    mounted(){
        //展示无用
        // eventBus.$on("defaultExpandedKeys", msg => {
        //     this.defaultExpandedKeys = [];
        //     this.defaultExpandedKeys.push(msg)
        // })
    },
    methods:{
        handleNodeClick(data, node, tag){
            tag.expanded = !tag.expanded
            if(!Array.isArray(data.children)){
                this.$emit('payloadId',data.id,true)
            }
        }
    }
}
</script>

<style scoped lang="less">
.food-container{
    padding: 18px;
    h1{
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 24px;
        margin-bottom: 10px;
    }
    .food-view{
        height: calc( 100% - 30px );
        .el-tree {
            & /deep/ .el-tree-node{
                margin-bottom: 5px;
            }
            & /deep/ .el-tree-node__label{
                font-size: 12px;

            }
        }
    }
}

</style>